import { Button, Heading, Tooltip } from '@sendible/design-system/src';
import { useBridgeUser } from '@sendible/shared-state-bridge';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionGroup, Header, HeadingWrapper } from '../../index.styles';
import { useCalendarContext, useCalendarSidebarContext } from '../../../../context';
import { shiftDay, toUtcMidnightDate } from '../../../../utils';

export const DaySidebarHeader = () => {
  const user = useBridgeUser();
  const { closeSidebar } = useCalendarContext();
  const { sidebarDay, setSidebarDay } = useCalendarSidebarContext();
  const { t } = useTranslation('calendar');

  const { weekdayLabel, dateLabel } = useMemo(() => {
    const d = toUtcMidnightDate(sidebarDay);

    const weekday = new Intl.DateTimeFormat(user?.language, { weekday: 'long', timeZone: 'UTC' }).format(d);
    const date = new Intl.DateTimeFormat(user?.language, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(d);

    return {
      weekdayLabel: weekday.toUpperCase(),
      dateLabel: date,
    };
  }, [sidebarDay, user?.language]);

  return (
    <Header>
      <ActionGroup>
        <Tooltip content={t('close')}>
          <Button
            onClick={closeSidebar}
            icon="close"
            size={14}
          />
        </Tooltip>
        <Tooltip content={t('previous_day')}>
          <Button
            onClick={() => setSidebarDay(shiftDay(sidebarDay, -1))}
            icon="chevron_left"
            size={14}
          />
        </Tooltip>
        <Tooltip content={t('next_day')}>
          <Button
            onClick={() => setSidebarDay(shiftDay(sidebarDay, 1))}
            icon="chevron_right"
            size={14}
          />
        </Tooltip>
        <HeadingWrapper>
          <Heading
            semantic="h3"
            variation="list-title_12"
          >
            {weekdayLabel}
          </Heading>
          <Heading
            semantic="h2"
            variation="component-title_20"
          >
            {dateLabel}
          </Heading>
        </HeadingWrapper>
      </ActionGroup>
    </Header>
  );
};
